import { connect } from 'react-redux';
import { getCurrentUserId } from '../../../../../publicSession/selectors';
var mapStateToProps = function (state, ownProps) {
    var _a, _b;
    return ({
        hasBlurredCoverTooltip: (_b = (((_a = ownProps.folder.thumb) === null || _a === void 0 ? void 0 : _a.premiumFolderData) &&
            ownProps.folder.owner &&
            getCurrentUserId(state) === ownProps.folder.owner.userId)) !== null && _b !== void 0 ? _b : false,
    });
};
export default connect(mapStateToProps);
//# sourceMappingURL=FolderContent.container.js.map